import { campaignHouseRuleSelection, isCritVariantRule } from '../janus-engine/authoring/campaign-house-rules';

let pendingSave: Promise<void> = Promise.resolve();

export function markCampaignHouseRuleGroups(): void {
    document.querySelectorAll<HTMLInputElement>('[data-ft-campaign-action="toggle-house-rule"]').forEach(input => {
        if (isCritVariantRule(input.dataset.ftHouseRuleId || '')) input.dataset.ftExclusiveGroup = 'crit-model';
    });
}

export function saveCampaignHouseRuleToggle(input: HTMLInputElement): Promise<void> {
    const campaignId = input.dataset.ftCampaignId || '';
    const rows = campaignHouseRuleSelection(input.dataset.ftHouseRuleId || '', input.checked);
    const table = input.closest('table');
    table?.querySelectorAll<HTMLInputElement>('[data-ft-campaign-action="toggle-house-rule"]').forEach(sibling => {
        if (sibling.dataset.ftCampaignId !== campaignId) return;
        const row = rows.find(row => row.campaign_house_rule_id === sibling.dataset.ftHouseRuleId?.toUpperCase());
        if (row) sibling.checked = row.campaign_house_rule_deleted === 0;
    });
    // Capture each click now and save in click order, including rapid switches between models.
    const url = input.dataset.ftToggleUrl || '';
    pendingSave = pendingSave.then(async () => {
        const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ campaign_id: campaignId, rows }), signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('The house-rule selection could not be saved.');
    }).catch(error => { displayWarning(error instanceof Error ? error.message : 'The house-rule selection could not be saved.'); });
    return pendingSave;
}
